export class IduraSDKError extends Error {}
